import React from 'react';
import { STATUTS } from './statuts';

// Barre lifecycle (même composant que le Dashboard)
const STEP_ORDER_D = [
  ['en_attente_paiement','brouillon','envoye'],
  ['paiement_partiel','signe','acompte_paye'],
  ['payee','solde_paye','contrat_envoye'],
  ['contrat_signe','a_preparer'],
  ['produits_charges','en_livraison'],
  ['livree'],
  ['en_location'],
  ['retour_a_effectuer'],
  ['retour_effectue','retour_anomalie','controle_termine'],
  ['facture_envoyee','avis_demande','terminee','livre','termine'],
];
function getStepIdx(statut) {
  for (let i = 0; i < STEP_ORDER_D.length; i++)
    if (STEP_ORDER_D[i].includes(statut)) return i;
  return 0;
}
export function LifecycleBarD({ statut }) {
  const total     = STEP_ORDER_D.length;
  const cur       = getStepIdx(statut);
  const isAnomaly = statut === 'retour_anomalie' || statut === 'annule' || statut === 'annulee';
  const sm        = STATUTS[statut] || STATUTS.brouillon;
  return (
    <div style={{ marginTop: 10 }}>
      <div style={{ display: 'flex', gap: 3, marginBottom: 5 }}>
        {STEP_ORDER_D.map((_, i) => (
          <div key={i} style={{
            height: 3, flex: 1, borderRadius: 3,
            background: isAnomaly && i === cur ? 'var(--admin-red)' :
                        i < cur  ? 'var(--admin-teal)' :
                        i === cur ? 'var(--admin-gold)' :
                        'var(--admin-surface2)',
          }} />
        ))}
      </div>
      <span className="text-xs font-semibold" style={{ color: isAnomaly ? 'var(--admin-red)' : sm.color }}>
        {sm.label}
      </span>
    </div>
  );
}
